import React from "react";
import { Checkbox, styled, Box, Typography } from "@mui/material";

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  ariaLabel?: string;
  indeterminate?: boolean;
}

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: "#A39455",
  "&.Mui-checked": {
    color: "#A39455",
    marginLeft:"1px",
  },
  "&.MuiCheckbox-indeterminate": {
    color: "#A39455",
  },
  "&:hover": {
    backgroundColor: "rgba(163, 148, 85, 0.08)",
  },
}));

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  label,
  ariaLabel,
  indeterminate,
}) => (
  <Box
    display="flex"
    alignItems="center"
  >
    <StyledCheckbox
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      inputProps={{ "aria-label": ariaLabel }}
    />
    <Typography variant="body1">{label ?? ""}</Typography>
  </Box>
);

export default CustomCheckbox;
